import { Injectable } from '@angular/core';
import { defaultRemoteConfig, FirebaseFlags } from '../../models/firebase/response/flags';
import firebase from 'firebase';
import { FirebaseRemoteConfigEvent } from 'src/app/ui/shared/event-listeners/firebase-remote-config/firebase-remote-config.event';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  tryNumber: number = 1;
  maxTryNumber: number = 3;
  timeoutInMiliseconds: number = 1000;

  constructor (
    private firebaseRemoteConfigEvent: FirebaseRemoteConfigEvent,
  ) {}

  getInitialRemoteConfig(): void {

    if (this.tryNumber > this.maxTryNumber) {
      this.tryNumber = 1;
      return;
    }

    try {
      const remoteConfig = firebase.remoteConfig();
      remoteConfig.settings = {
        minimumFetchIntervalMillis: 60 * 1000,
        fetchTimeoutMillis: 60 * 1000,
      };

      remoteConfig.fetchAndActivate()
        .then(() => this.setRemoteConfig(remoteConfig))
        .catch((error) => {
          console.error('Error fetching remote config', error);
          this.tryNumber++;
          setTimeout(() => this.getInitialRemoteConfig(), this.timeoutInMiliseconds);
        });
    } catch (error) {
      console.error('Error fetching remote config', error);
    }
  }

  setRemoteConfig(remoteConfig: firebase.remoteConfig.RemoteConfig): void {

    this.tryNumber = 1;

    let farmacreditsConfig: FirebaseFlags['farmacreditsConfig'] = defaultRemoteConfig.farmacreditsConfig;
    let configShowEta: FirebaseFlags['configShowEta'] = defaultRemoteConfig.configShowEta;
    let authActiveConfig: FirebaseFlags['authActiveConfig'] = defaultRemoteConfig.authActiveConfig;
    let verify_medical_formula_config: FirebaseFlags['verify_medical_formula_config'] = defaultRemoteConfig.verify_medical_formula_config;
    let chatConfig: FirebaseFlags['chatConfig'] = defaultRemoteConfig.chatConfig;

    const activeCovid: FirebaseFlags['activeCovid'] = remoteConfig?.getBoolean('active_covid');
    const vipModalEnabled: FirebaseFlags['vipModalEnabled'] = remoteConfig?.getBoolean('vip_modal_enabled');
    const qualtricsActive: FirebaseFlags['qualtricsActive'] = remoteConfig?.getBoolean('qualtrics_active');
    const searchMarketplace: FirebaseFlags['searchMarketplace'] = remoteConfig?.getBoolean('search_marketplace');
    const showRxProducts: FirebaseFlags['showRxProducts'] = remoteConfig?.getBoolean('show_rx_products');
    const cuidamosTuSalud: FirebaseFlags['cuidamosTuSalud'] = remoteConfig?.getBoolean('cuidamos_tu_salud');

    const verify_medical_formula_config_string = remoteConfig?.getString('verify_medical_formula_config');
    const configString = remoteConfig?.getString('farmacredits_config');
    const configShowEtaString = remoteConfig?.getString('config_show_eta');
    const authActiveConfigString = remoteConfig?.getString('auth_active_config');
    const chatConfigString = remoteConfig?.getString('app_zendesk_config');

    if (configString) { farmacreditsConfig = JSON.parse(configString); }
    if (configShowEtaString) { configShowEta = JSON.parse(configShowEtaString); }
    if (authActiveConfigString) { authActiveConfig = JSON.parse(authActiveConfigString); }
    if (verify_medical_formula_config_string) { verify_medical_formula_config = JSON.parse(verify_medical_formula_config_string); }
    if (chatConfigString) { chatConfig = JSON.parse(chatConfigString); }

    const firebaseFlags: FirebaseFlags = {
      activeCovid,
      vipModalEnabled,
      qualtricsActive,
      searchMarketplace,
      farmacreditsConfig,
      configShowEta,
      authActiveConfig,
      verify_medical_formula_config,
      showRxProducts,
      chatConfig,
      cuidamosTuSalud
    };

    this.firebaseRemoteConfigEvent.update(firebaseFlags);
  }
}
